<script>
import MediaPreview from "./MediaPreview.vue";

export default {
  name: "MediaGrid",
  components: { MediaPreview },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    selectedIds: {
      type: Array,
      default: () => [],
    },
    currentId: {
      type: [Number, String],
      default: null,
    },
    selectable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    isSelected(item) {
      return this.selectedIds.includes(item.id);
    },
    isCurrent(item) {
      return this.currentId === item.id;
    },
    onItemClick(item) {
      if (!this.selectable) {
        this.$emit("select", item);
        return;
      }
      this.$emit("toggle", item);
    },
  },
};
</script>

<template>
  <div class="media-preview-container">
    <div
      v-for="item in items"
      :key="item.id"
      class="media-preview-item"
      :class="{
        selected: isSelected(item),
        'current-selected': isCurrent(item),
      }"
      @click="onItemClick(item)"
    >
      <MediaPreview :item="item" />
    </div>
    <div v-if="!items.length" class="text-muted w-100 text-center py-4">
      No hay archivos para mostrar.
    </div>
  </div>
</template>
